import _map from 'lodash/map';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_DEVICE_DISTRIBUTIONS_HISTORY,
  GET_DEVICE_DISTRIBUTIONS_HISTORY_SUCCESS,
  GET_DEVICE_DISTRIBUTIONS_HISTORY_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserializeDistributionHistory } from '../../models/device';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.deviceDistribution;
const deviceDistribution = (state = initialSettings, action) => {
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      if (action.target === 'deviceDistribution') {
        return {
          ...initialSettings,
        };
      }
      return state;
    // HISTORY
    case GET_DEVICE_DISTRIBUTIONS_HISTORY:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: null,
        },
      };
    case GET_DEVICE_DISTRIBUTIONS_HISTORY_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case GET_DEVICE_DISTRIBUTIONS_HISTORY_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: _map(action.data.data, (deviceDistributionHistory) => (
            deserializeDistributionHistory({
              id: deviceDistributionHistory.distribution.id,
              ...deviceDistributionHistory,
            })
          )),
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default deviceDistribution;



// WEBPACK FOOTER //
// ./reducers/device/deviceDistribution.js